import { render } from "./ClientInventarioUnidadesMedida.vue?vue&type=template&id=5c2b1f58&scoped=true"
import script from "./ClientInventarioUnidadesMedida.vue?vue&type=script&lang=js"
export * from "./ClientInventarioUnidadesMedida.vue?vue&type=script&lang=js"

import "./ClientInventarioUnidadesMedida.vue?vue&type=style&index=0&id=5c2b1f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2b1f58"]])

export default __exports__